const emailEventsOptions = [
    { label: "wave_performance:deployed", value: 20 },
    { label: "wave_performance:opened", value: 23 },
    { label: "wave_performance:clicked", value: 27 },
    { label: "wave_performance:bounced", value: 21 },
    { label: "wave_performance:unsubscribed", value: 24 }
];

export default emailEventsOptions;